export enum KCSMBLoanPrepCustomQuestionKeys {
  LOAN_AMOUNT = 'loanAmount',
  OTHER_RELATED_BUSINESSES = 'otherRelatedBusinesses',
  OWNER_INFORMATION = 'ownerInformation',
  PRIMARY_CONTACT_NAME = 'primaryContactName',
  PRIMARY_CONTACT_TITLE = 'primaryContactTitle',
  PURPOSE_OF_FINANCING = 'purposeOfFinancing',
  BANK_OR_FINANCIAL_INSTITUTION = 'bankOrFinancialInstitution',
  YTD_EXPENSES = 'YTDExpenses',
  PERSONAL_INCOME_AND_EXPENSES = 'personalIncomeAndExpenses',
  BUSINESS_PAYS_INCOME = 'businessPaysIncome',
  HAVE_ANY_OPEN_LOANS = 'haveAnyOpenLoans',
  FISCAL_YEAR_FINANCIAL_INFORMATION = 'fiscalYearFinancialInformation',
  SUPPORTING_DOCUMENTS = 'supportingDocuments',
  CAN_COMMIT_TO_STATUS_UPDATES = 'canCommitToStatusUpdates',
}
